/**
 * Global TopNav component.
 */

// import primary libararies
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import classNames from 'classnames';

// import components
import Base from '../BaseComponent.js.jsx';
import CloseWrapper from '../helpers/CloseWrapper.js.jsx';
import ProfileDropdownNav from './ProfileDropdownNav.js.jsx';
import UserProfilePic from '../../../modules/user/components/UserProfilePic.js.jsx';

class TopNav extends Base {
  constructor(props, context) {
    super(props);
    this.state = {
      isOpen: false
      , scrollingDown: false
      , isTop: true
    }
    this._bind(
      '_openDropdown'
      , '_closeDropdown'
    );
  }

  _openDropdown(e) {
    e.stopPropagation();
    this.setState({
      isOpen: true
    });
  }

  _closeDropdown() {
    this.setState({
      isOpen: false
    });
  }

  render() {
    let { loggedInUser } = this.props;
    let { isTop, scrollingDown, isFixed } = this.state;
    let headerClass = classNames(
      'header'
      , 'full-width'
      // , 'fixed'
    )
    const dashboardUrl = `${window.hubUrl}`
    const trainingUrl = `${window.agendaUrl}/agenda`
    const libraryUrl = `${window.libraryUrl}`


    return(
      <header className={headerClass}>
        <div className="topbar -main-nav">
          <CloseWrapper
            isOpen={this.state.isOpen}
            closeAction={this._closeDropdown}
          />
          <div className="titles">
            <NavLink to="/" className="nav-logo" >
              <img src="https://pro-ficiency-static.s3.us-east-2.amazonaws.com/atlas/pf_full_white.png"/>
            </NavLink>
          </div>
          <div className="actions">
            <div className="yt-row center-vert right">
              { loggedInUser && loggedInUser.username ?
                <ul className="navigation">
                  <li className="dropdown">
                    <span className="action-link" onClick={this._openDropdown}>
                      <UserProfilePic user={loggedInUser} classes='-nav' />
                    </span>
                    <ProfileDropdownNav
                      close={this._closeDropdown}
                      isOpen={this.state.isOpen}
                    />
                  </li>
                </ul>
                :
                null
              }
              { !loggedInUser || !loggedInUser.username ?
                  <div className="yt-row">
                    <NavLink to="/user/login" className="yt-btn small link ">Sign In</NavLink>
                    <NavLink to="/user/register" className="yt-btn small ">Register</NavLink>
                  </div>

                :
                  null
              }
            </div>
          </div>
        </div>
        <div className="subbar">
          <a href={dashboardUrl} className="titles">
            <div className="menu-icon">
              <i className="fa-regular fa-house fa-sm"></i>
            </div>
            <p className="active-link">DASHBOARD</p>
          </a>
          <div className="divider"/>
          <Link to={trainingUrl} className="titles -current">
            <div className="menu-icon -current">
              <i className="fa-solid fa-graduation-cap fa-sm"></i>
            </div>
            <p className="active-link -current">TRAINING</p>
          </Link>
          <a href={libraryUrl} className="titles">
            <div className="menu-icon">
              <i className="fa-regular fa-books fa-sm"></i>
            </div>
            <p className="active-link">LIBRARY</p>
          </a>
        </div>
      </header>
    )
  }

}

TopNav.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(TopNav)
);



// WEBPACK FOOTER //
// global/components/navigation/TopNav.js.jsx